import { render } from "./Allgemein.vue?vue&type=template&id=ddc53366&scoped=true&ts=true"
import script from "./Allgemein.vue?vue&type=script&lang=ts"
export * from "./Allgemein.vue?vue&type=script&lang=ts"

import "./Allgemein.vue?vue&type=style&index=0&id=ddc53366&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc53366"]])

export default __exports__